<template>
  <div class="customer_login">
    <div class="login_inner" v-if="selectDealCompany != ''">
      <div class="inner_txt_1">
        <img
          src="@/assets/front/images/v2/logos/logo_perce_header.svg"
          alt="perce"
        />
      </div>
      <div class="inner_txt_4">
        {{ selectDealCompany }} 회원의<br />
        퍼스휴대폰 특가 구매 상담.신청을 위해
      </div>
      <div class="inner_txt_5">
        <div>간단 로그인이 필요합니다!</div>
      </div>
    </div>
    <div class="login_inner" v-else>
      <div class="inner_txt_1">
        <img
          src="@/assets/front/images/v2/logos/logo_perce_header.svg"
          alt="perce"
        />
      </div>
      <div class="inner_txt_2">초간단 지원금 견적비교</div>
      <div class="inner_txt_3">
        <div>지금 바로,</div>
        <div>시작해 볼까요?</div>
      </div>
    </div>
    <div class="login_btn_area">
      <button class="btn_kakao" @click="kakaoLogin">
        <img
          :src="
            require('@/assets/front/images/v2/logos/symbol_login_kakao.svg')
          "
        />
        <span>카카오 로그인</span>
      </button>
      <button class="btn_perce" @click="mobileLogin">
        <img
          :src="
            require('@/assets/front/images/v2/logos/symbol_login_perce.svg')
          "
        />
        <span>휴대폰 번호 로그인</span>
      </button>
      <button
        class="btn_apple"
        @click="appleLogin"
        v-if="isShowApple && isAppVerChk"
      >
        <img
          :src="
            require('@/assets/front/images/v2/logos/symbol_login_apple.svg')
          "
        />
        <span>Apple로 로그인</span>
      </button>
    </div>
    <AppAccessAuthorityModal
      :show="isShowAppAccessAuthorityModal"
      @close="hideAppAccessAuthorityModal"
    />
    <AppDownloadModal
      :isOpen="isShowAppDownload"
      @close="isCloseAppDownload"
    ></AppDownloadModal>
  </div>
</template>
<script>
import AppDownloadModal from '@/common/components/modal/AppDownloadModal';
import StorageFactory from '@common/lib/common/storage';
import AppAccessAuthorityModal from '@/front/customer/views/auth/modal/AppAccessAuthorityModal';
import { authMapActions, authTypes } from '@common/store/modules';
import {
  mapActions as userMapActions,
  mapGetters as userMapGetters,
} from '@common/store/modules/user';
import * as userTypes from '@common/store/modules/user/types';
import {
  mapActions as mapXeronoteActions,
  mapGetters as mapXeronoteGetters,
} from '@common/store/modules/xeronote';
import * as xeronoteTypes from '@common/store/modules/xeronote/types';
import {
  sleep,
  nativeDeviceInfo,
  nativeLocation,
  isApp,
  checkMobile,
  checkMobileOperatingSystem,
  nativeKakaoLogin,
  mobileNumberFormat,
  nativeAppleLogin,
  // initLocation,
} from '@common/lib/common/utils';

import {
  mapActions as commonMapActions,
  mapState as commonMapState,
  mapGetters as commonMapGetters,
} from '@common/store/modules/common';
import * as commonActions from '@common/store/modules/common/types';
import * as commonGetters from '@common/store/modules/common/getters';

import {
  mapActions as mobileMapActions,
  mapGetters as mobileMapGetters,
} from '@common/store/modules/mobile';
import * as mobileTypes from '@common/store/modules/mobile/types';

export default {
  components: {
    AppAccessAuthorityModal,
    AppDownloadModal,
  },
  data() {
    return {
      isShowAppAccessAuthorityModal: false, // 권한 팝업
      myDeviceName: '',
      myTelecomName: '',
      isExDeal: false,
      dl: '',
      dealId: 0,
      dealCompany: [
        { id: 'ocb', name: 'OK캐쉬백' },
        { id: 'hanapay', name: '하나페이' },
        { id: 'perce', name: '퍼스' },
      ],
      selectDealCompany: '',
      redir: '',
      isRedir: false,
      isShowAppDownload: false,
    };
  },
  created() {
    console.log('this.$route');
    console.log(this.$route);

    // 외부에서 특가 상품 접속시 처리 (index.js에서 처리)
    // 파라미터로 처리 dl_id 값이 ocb_1(id값), hanapay_1(id값), perce_1(id값) 만 허용
    if (this.$route.query.dl_id && !isApp()) {
      this.isExDeal = true;

      let dl_id_sp = this.$route.query.dl_id.split('_');

      this.dl = dl_id_sp[0];
      this.dealId = dl_id_sp[1];

      const foundInfo = this.dealCompany.filter(info => info.id == this.dl);

      this.selectDealCompany = foundInfo[0].name;

      localStorage.setItem('dl_id', this.$route.query.dl_id);
    } else {
      this.isExDeal = false;
      localStorage.removeItem('dl_id');
      this.selectDealCompany = '';
    }

    // 외부에서 특가 상품 접속시 처리 (index.js에서 처리)
    // http://172.30.1.85:3001/Mobile/ApplyList?dl=hanapay
    // http://172.30.1.85:3001/Shops/List/3067
    if (this.$route.query.redir && !isApp()) {
      this.isRedir = true;
      localStorage.setItem('redir', this.$route.query.redir);

      if (this.$route.query.redir.indexOf('hanapay') != -1) {
        this.selectDealCompany = '하나페이';
      }
    } else {
      this.isRedir = false;
      localStorage.removeItem('redir');
      this.selectDealCompany = '';
    }
    this.$nextTick(() => {
      // 모바일일때
      if (!isApp() && checkMobile()) {
        this.isShowAppDownload = true;
      }
    });
  },
  mounted() {
    if (this.isFirstRun()) {
      this.isShowAppAccessAuthorityModal = true;
    }
  },
  computed: {
    ...commonMapGetters({
      appInfo: commonGetters.APPINFO,
    }),
    isShowApple() {
      if (!isApp()) return false;
      return checkMobileOperatingSystem() === 'iOS';
    },
    // 애플로그인, 카카오로그인 버튼 os version 13.0 이상이어야 가능
    isAppVerChk() {
      if (parseFloat(this.appInfo.osVersion) >= 13) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    ...mobileMapActions([mobileTypes.MOBILE_DEAL_CHAT]),
    ...authMapActions([authTypes.REGISTER_MOBILE, authTypes.LOGIN]),
    ...userMapActions([
      userTypes.FIND_USER_BY_MOBILE_NUMBER,
      userTypes.FETCH_ME,
      userTypes.SET_USER,
      userTypes.UPDATE_USER_TELECOM_AND_DEVICE,
      userTypes.USER_UPDATE_ME,
    ]),
    ...mapXeronoteActions([xeronoteTypes.FETCH_NICKNAME]),
    ...authMapActions([authTypes.SOCIAL_CHECK, authTypes.SOCIAL_REGISTER]),
    handleAnimation: function(anim) {
      this.anim = anim;
    },
    mobileLogin() {
      localStorage.setItem('join_method', 'mobile');
      this.$router.push({
        name: 'Auth.JoinMobile',
      });
    },
    async kakaoLogin() {
      if (isApp()) {
        await nativeKakaoLogin();
      } else {
        window.Kakao.Auth.login({
          scope: 'account_email, gender, age_range, phone_number',
          success: this.getKakaoAccount,
        });
      }
    },
    async getKakaoAccount() {
      await window.Kakao.API.request({
        url: '/v2/user/me',
        success: result => {
          console.log('resultresultresultresult');
          console.log(result);
          const account = result.kakao_account;
          var mobileNumber = mobileNumberFormat(account.phone_number);

          let params = {
            providerId: 'KAKAO',
            providerUserId: result.id,
            mobileNumber: mobileNumber,
          };

          // 카카오 로그인 기록 확인
          this[authTypes.SOCIAL_CHECK](params).then(res => {
            console.log('resresresresres');
            console.log(res);
            // 카카오 로그인 기록 있음
            if (res.isUser) {
              const passwordkey = '_KAKAO';
              const username = mobileNumber;
              const password = `${params.providerUserId}${mobileNumber}${passwordkey}`;
              // kakao 로그인
              this.login(username, password, 12);
            } else {
              // 카카오 로그인 기록 없음
              const reg_params = {
                providerId: 'KAKAO',
                providerUserId: result.id,
                email: account.email,
                gender: account.gender,
                ageRange: account.age_range,
                mobileNumber: mobileNumber,
                // nickname: res.nickname,
                // areaId: region.areaId,
                // codeType: region.codeType,
              };

              // res 에서 닉네임이 있는경우 (다른 방법으로 로그인한 기록이 있음)
              if (res.nickname != '' && res.nickname != null) {
                reg_params.nickname = res.nickname;

                if (isApp()) {
                  reg_params.joinRoute = 'APP';
                } else {
                  if (checkMobile()) {
                    reg_params.joinRoute = 'MOBILE';
                  } else {
                    reg_params.joinRoute = 'PC';
                  }
                }
                // 1. 카카오 로그인 기록 등록 (소셜 등록)
                this[authTypes.SOCIAL_REGISTER](reg_params).then(res => {
                  // 기존회원
                  // if (res.isUser) {
                  //   // 그냥 로그인
                  // } else {
                  //   // 기존 회원 아님 신규 회원 가입됨
                  // }

                  const passwordkey = '_KAKAO';
                  const username = mobileNumber;
                  const password = `${reg_params.providerUserId}${mobileNumber}${passwordkey}`;

                  this.login(username, password, 12);
                });
              } else {
                // res 에서 닉네임이 없는경우
                localStorage.setItem('join_method', 'kakao');
                localStorage.setItem(
                  'join_kakao_info',
                  JSON.stringify(reg_params),
                );

                this.$router.push({
                  name: 'Auth.JoinRegion',
                });
              }
            }
          });
        },
        fail: err => {
          console.log('err :: {}', err);
        },
      });
    },
    async appleLogin() {
      console.log(checkMobileOperatingSystem());

      // nativeKakaoLoginTest();
      if (isApp() && checkMobileOperatingSystem() === 'iOS') {
        await nativeAppleLogin();
      }
    },
    async login(username, password, roles = 10) {
      let loginParam = {
        username: username,
        password: password,
        roles: roles,
      };
      console.log('loginParam :: {}', loginParam);

      await this[authTypes.LOGIN](loginParam).then(() => {
        if (this.isExDeal) {
          // 채팅방으로 이동 처리
          this.enterChatRoom(this.dealId);
        } else {
          if (this.isRedir) {
            this.$router.push({ path: this.$route.query.redir }).catch(err => {
              this.$router.push({ name: 'Home' });
            });
          } else {
            this.$router.push({ name: 'Home' });
          }
        }
      });
    },
    async getDevice() {
      nativeDeviceInfo();
      await sleep(800);
      this.myDeviceName = window.$bridge.deviceModelName || '';
      this.myTelecomName = window.$bridge.telecomName || '';
    },

    hideAppAccessAuthorityModal() {
      let storage = StorageFactory({
        storageType: 'localStorage',
      });
      storage.setItem('isFirstRun', 'false');
      this.isShowAppAccessAuthorityModal = false;

      if (isApp()) {
        this.getDevice();
        nativeLocation();
      }
    },
    isFirstRun() {
      let storage = StorageFactory({
        storageType: 'localStorage',
      });
      if (storage.getItem('isFirstRun')) {
        sleep(1000);
        // nativeDeviceInfo();
        this.getDevice();
        nativeLocation();
        // initLocation();
        return false;
      } else {
        // storage.setItem('isFirstRun', 'false');
        return true;
      }
    },
    enterChatRoom(id) {
      const params = {
        id: id,
      };

      this[mobileTypes.MOBILE_DEAL_CHAT](params)
        .then(res => {
          console.log('resresresresresresres');
          console.log(res);

          this.$router.push({
            name: 'chat.room',
            params: {
              uuid: res,
            },
          });
        })
        .catch(e => {
          console.log('error');
        });
    },
    isCloseAppDownload(sel) {
      if (sel == 'WEB') {
        // 웹으로 보기
      } else if (sel == 'APP') {
        // 앱 다운로드하기
        if (checkMobileOperatingSystem() === 'iOS') {
          window.open(
            'https://apps.apple.com/us/app/%ED%8D%BC%EC%8A%A4-perce/id1569722707',
            '_blank',
          );
        } else {
          window.open(
            'https://play.google.com/store/apps/details?id=com.appg.perce_customer',
            '_blank',
          );
        }
      }
      this.isShowAppDownload = false;
    },
  },
};
</script>
